import { diffNotes } from './notes-diff.js';

/**
 * Renderiza o `notes` da proposta com os trechos adicionados envoltos
 * em `<mark>` com fundo âmbar. Usado na `ProposalPublicView` quando
 * a Karla ajustou o texto depois da dúvida do lead — sem isso, o
 * texto inteiro aparece sem distinguir o que mudou (a dor que o
 * Alexandre reportou em 2026-04-24).
 *
 * Os parágrafos são mantidos via `whitespace-pre-wrap` no wrapper
 * que envolve este componente — aqui só emitimos `<mark>` e `<span>`
 * inline. Se `before` for null/vazio, cai no estado "tudo novo" e
 * marca tudo (comportamento do `diffNotes`).
 *
 * O fallback (quando `before === after` ou ambos vazios) é renderizar
 * o texto cru — o caller decide quando chamar este componente via
 * `didChange('notes')`. */
export function NotesDiffView({
  before,
  after,
}: {
  before: string | null | undefined;
  after: string | null | undefined;
}) {
  const parts = diffNotes(before, after);

  if (parts.length === 0) return null;

  return (
    <>
      {parts.map((part, idx) =>
        part.kind === 'added' ? (
          // `rounded-sm px-0.5` dá um toque de "marca-texto" ao highlight
          // sem interromper a linha base do texto. Tons escolhidos pra
          // contrastar com fundo claro (proposal view usa bg branco/muted).
          // Dark mode tem opacidade menor pra não ofuscar o texto.
          <mark
            key={idx}
            className="rounded-sm bg-amber-200 px-0.5 text-foreground dark:bg-amber-400/30"
          >
            {part.value}
          </mark>
        ) : (
          <span key={idx}>{part.value}</span>
        ),
      )}
    </>
  );
}
